import neokredLogo from "../../assets/svg/Neokred_Logo.svg";
import { ReactComponent as dashboardicon } from "../../assets/svg/dashboardicon.svg";
import { ReactComponent as apiDocIconDashboard } from "../../assets/svg/apiDocIcon.svg";
import { ReactComponent as roleManagement } from "../../assets/svg/roleManagement.svg";
import { ReactComponent as client } from "../../assets/svg/client.svg";
import { ReactComponent as reseller } from "../../assets/svg/resellerIcon.svg";
import { ReactComponent as van } from "../../assets/svg/van.svg";
import { ReactComponent as transactionicon } from "../../assets/svg/transactionIcon.svg";
import { ReactComponent as settlementicon } from "../../assets/svg/settlement.svg";
import { ReactComponent as commissionicon } from "../../assets/svg/commission.svg";
import { ReactComponent as customericon } from "../../assets/svg/customercenter.svg";
import { ReactComponent as accountlogouticon } from "../../assets/svg/account_logout.svg";
import { ReactComponent as notificationicon } from "../../assets/svg/notification.svg";
import { ReactComponent as addresellericon } from "../../assets/svg/addreseller.svg";
import { ReactComponent as addclienticon } from "../../assets/svg/addclient.svg";
import { ReactComponent as userapprovalicon } from "../../assets/svg/userapproval.svg";
import { ReactComponent as userapprovalmenuicon } from "../../assets/svg/userapprovalmenu.svg";
import { ReactComponent as deactivateicon } from "../../assets/svg/deactivate.svg";
import PasswordHider_Icon from "../../assets/svg/passwordhide.svg";
import PasswordView_Icon from "../../assets/svg/passwordvisible.svg";
import NeokredLogoNew from "../../assets/png/Neokred_Logo.png";
import { ReactComponent as addSlabIcon } from "../../assets/svg/addslab.svg";
import clearicon from "../../assets/svg/clear.svg";
import backcon from "../../assets/svg/back.svg";
import { ReactComponent as infotext } from "../../assets/svg/info-circle.svg";
import { ReactComponent as EditAlt } from "../../assets/svg/edit-alt.svg";
import { ReactComponent as DownloadSvg } from "../../assets/svg/download.svg";
import { ReactComponent as AddPrefund } from "../../assets/svg/addprefund.svg";
import { ReactComponent as SendMoney } from "../../assets/svg/sendmoney.svg";
import { ReactComponent as DocUploadSvg } from "../../assets/svg/documentupload.svg";
import { ReactComponent as DownloadSampleSvg } from "../../assets/svg/downloadsample.svg";
import { ReactComponent as DocUploadedSvg } from "../../assets/svg/documenttext.svg";
import { ReactComponent as DocCancelSvg } from "../../assets/svg/cancel.svg";
import { ReactComponent as ViewSvg } from "../../assets/svg/eye.svg";
import { ReactComponent as CommentSvg } from "../../assets/svg/comment.svg";
import { ReactComponent as DocDownload } from "../../assets/svg/document-download.svg";
import { ReactComponent as ViewsSvgs } from "../../assets/svg/eye2.svg";
import loadergif from "../../assets/gif/loader.gif";
import successgif from "../../assets/gif/Success.gif";
import add from "../../assets/svg/Addsymbol.svg";
import percent from "../../assets/svg/percentage.svg";
import rupee from "../../assets/svg/rupee.svg";
import symbolAdd from "../../assets/svg/symbolAdd.svg";
import downloadSymbol from "../../assets/svg/download-sample.svg";
import { ReactComponent as upwardarrowmark } from "../../assets/svg/upward.svg";
import { ReactComponent as Eye } from "../../assets/svg/eyelight.svg";
import { ReactComponent as ArrowDownSvg } from "../../assets/svg/arrowdown.svg";
import { ReactComponent as NewCommentSvg } from "../../assets/svg/newcomment.svg";
import { ReactComponent as UploadSvg } from "../../assets/svg/upload.svg";
import { ReactComponent as SendMessageSvg } from "../../assets/svg/sendmessage.svg";
import { ReactComponent as Download } from "../../assets/svg/downloading.svg";
import { ReactComponent as Refresh } from "../../assets/svg/refresh.svg";
import { ReactComponent as Filter } from "../../assets/svg/filters.svg";
import { ReactComponent as Search } from "../../assets/svg/search.svg";
import { ReactComponent as lineSymbol } from "../../assets/svg/linesymbol.svg";
import { ReactComponent as Rightarrow } from "../../assets/svg/rightarrow.svg";
import { ReactComponent as approve } from "../../assets/svg/approve.svg";
import { ReactComponent as reject } from "../../assets/svg/reject.svg";
import { ReactComponent as timerClock } from "../../assets/svg/clocktimer.svg";
import { ReactComponent as UpiLogo } from "../../assets/svg/upi.svg";
import { ReactComponent as deleteIcon } from "../../assets/svg/delete.svg";
import collectbotlogo from "../../assets/svg/collectbotlogo.svg";
import collectbotbglogo from "../../assets/svg/BG.svg";
import cloudUpload from "../../assets/svg/cloud-upload.svg";
import { ReactComponent as Copy } from "../../assets/svg/Copy.svg";

export const NeokredNewLogo = NeokredLogoNew;
export const TimerClock = timerClock;
export const CopyLogo = Copy;
export const cloud = cloudUpload;
export const LineSymbol = lineSymbol;
export const RightArrow = Rightarrow;
export const Downloadopt = Download;
export const Refreshopt = Refresh;
export const Filteropt = Filter;
export const Searchopt = Search;
export const Eyelight = Eye;
export const SymAdd = symbolAdd;
export const Upwardarrow = upwardarrowmark;
export const percentage = percent;
export const Rupee = rupee;
export const Add = add;
export const NeokredLogo = neokredLogo;
export const DashboardRouteIcon = dashboardicon;
export const ApiDocRouteIcon = apiDocIconDashboard;
export const RoleManagementIcon = roleManagement;
export const ClientIcon = client;
export const ResellerIcon = reseller;
export const VanIcon = van;
export const TransactionIcon = transactionicon;
export const SettlementIcon = settlementicon;
export const CommissionIcon = commissionicon;
export const CustmerIcon = customericon;
export const AccountLogoutIcon = accountlogouticon;
export const NotificationIcon = notificationicon;
export const AddResellerIcon = addresellericon;
export const AddClientIcon = addclienticon;
export const UserApprovalIcon = userapprovalicon;
export const UserApprovalMenuIcon = userapprovalmenuicon;
export const PasswordHide = PasswordHider_Icon;
export const PasswordView = PasswordView_Icon;
export const AddSlabIcon = addSlabIcon;
export const ClearSvg = clearicon;
export const BackSvg = backcon;
export const DeactivateIcon = deactivateicon;
export const InfoTextIcon = infotext;
export const EditAltIcon = EditAlt;
export const DownloadIcon = DownloadSvg;
export const AddPrefundSvg = AddPrefund;
export const SendMoneySvg = SendMoney;
export const LoaderGif = loadergif;
export const SuccessGif = successgif;
export const Docdownload = DocDownload;
export const ViewsIcons = ViewsSvgs;

export const DocUploadIcon = DocUploadSvg;
export const DocUploadedIcon = DocUploadedSvg;
export const DocCancelIcon = DocCancelSvg;
export const ViewIcon = ViewSvg;
export const DownloadSampleIcon = DownloadSampleSvg;
export const CommentIcon = CommentSvg;
export const ArrowDown = ArrowDownSvg;
export const NewComment = NewCommentSvg;
export const Upload = UploadSvg;
export const SendMessage = SendMessageSvg;
export const Approve = approve;
export const Reject = reject;
export const downloadSym = downloadSymbol;
export const CollectBotLogo = collectbotlogo;
export const CollectBotBgLogo = collectbotbglogo;
export const UpiCollectLogo = UpiLogo;
export const DeleteIcon = deleteIcon;
